import * as React from 'react';

interface ButtonTypes {
	children?: React.ReactNode;
	type?: 'submit' | 'reset' | 'button';
	className?: string;
	disabled?: boolean;
	buttonIcon?: React.ReactElement;
	buttonIconPath?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const Button: React.FC<ButtonTypes> = ({
	children,
	type = 'button',
	className = '',
	disabled,
	buttonIcon,
	buttonIconPath,
	onClick
}) => {
	return (
		<button type={type} className={'btn ' + className} disabled={disabled} onClick={onClick}>
			{!!buttonIcon ? buttonIcon : buttonIconPath ? <img alt="icon" src={buttonIconPath} /> : ''}
			{children}
		</button>
	);
};

export default Button;
